import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "app/components/simple-success-error-dialog-box/simple-success-error-dialog-box.component";
import { ServiceInstance } from "app/models/service-instance";
import { OneillService } from "app/services/oneill.service";
import { CookieService } from "ngx-cookie-service";

const CookieKey_SelectedPortal = "page[oneil-portal.select-portal]-key[selected-portal-id]";

@Component({
    templateUrl: './oneil-portal-validation.select-portal.component.html',
    styleUrls: ['./oneil-portal-validation.select-portal.component.css']
  })
export class OneilPortalValidationSelectPortalComponent implements OnInit {

  /** Reference to the SimpleSuccessErrorDialog used to display error */
@ViewChild('successErrorDialog') 
simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  /** Portals available for the User to select from */
  availablePortals: ServiceInstance[] = [];

  /** Currently selected Portal in the UI */
  selectedPortal: ServiceInstance = null;

  isUiDisabled = false;

  /** Constructor */
  constructor(
    private oneilService: OneillService,
    private cookieService: CookieService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  /**
   * Initializes the component.  
   * Called automatically by the Angular Component Lifecycle.
   */
  ngOnInit(): void {
    console.log(`ngOnInit()`);
    // Subscribe to the Route to grab the data that was resolved in the background
    this.route.data.subscribe((data: {
      availablePortals: ServiceInstance[]
    }) => {
      this.setAvailablePortals(data.availablePortals);
    });
  }

  /**
   * Updates the available Portals for the User to select from.
   * This also auto-selects the stored "Previously selected Portal" from the Cookie.
   */
  async setAvailablePortals(portals: ServiceInstance[]): Promise<void> {
    // Update the portals available to select from for the User
    while(this.availablePortals.length > 0) {
      this.availablePortals.pop();
    }
    if (portals?.length > 0) {
      this.availablePortals.push(...portals);
    }

    // Select the previously selected Portal by default
    const selectedPortalId = this.getStoredPortalId();
    const selectedPortal = this.availablePortals.find(portal => portal?.id == selectedPortalId);
    console.log(selectedPortal);
    this.selectedPortal = selectedPortal != null && selectedPortal != undefined? selectedPortal : null;
  }

  /**
   * Called to handle errors when calling APIs.  
   * Currently this prints them out to the console and displays an alert to the User.
   */
  handleError(error: any): void {
    if (error?.error != null) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.error);
    }
    /* Default back to old handling */
    else if (error != null) {
      const response: Response = error;
    }
  }

  /**
   * Returns the stored "Portal ID" value from the Cookie.
   * This is used to auto-select the previously selected Portal (if available).
   */
  private getStoredPortalId(): number {
    const value = this.cookieService.get(CookieKey_SelectedPortal);
    if (value == null || value == undefined || value.trim().length == 0) {
      return null;
    } else {
      const storedValue: StoredPortalId = JSON.parse(value);
      return storedValue.portal_id;
    }
  }

  /**
   * Sets the stored "Portal ID" value to the Cookie.
   * This is used in the auto-select logic to have the previously selected Portal 
   * auto-selected (if available).
   */
  private setStoredPortalId(id: number): void {
    const value = { portal_id: id } as StoredPortalId;
    this.cookieService.set(CookieKey_SelectedPortal, JSON.stringify(value), 1, '/', null, false, 'Lax');
  }

  onSelectPortalClicked(): void {
    console.log(`onSelectPortalClicked() - Is UI Disabled: ${this.isUiDisabled}`);
    if (!this.isUiDisabled) {
      this.isUiDisabled = true;
      this.selectPortal();
    }
  }

  private async selectPortal(): Promise<void> {
    console.log("InSelectPortal - " + this.selectedPortal);
    if (this.selectedPortal?.id != null) {
      const selectedPortal = this.selectedPortal.id;
      this.setStoredPortalId(selectedPortal);

      this.router.navigate(['oneill', 'carton-portal-validation', selectedPortal, 'dashboard'], {});
      this.isUiDisabled = false;
    }
  }
}

/**
 * Interface representing the stored "Portal ID" value in the Cookie as JSON.
 */
interface StoredPortalId {
  portal_id: number;
}
